<template>
  <div class="col-l-12 col-m-12 col-12 gdwrapper" v-for="(value, index) in songRegistration.writerInfo" :key="index">
    <FormInput :data-field="'firstname-'+ index" place-holder="First Name" v-model="value.firstName" />
    <FormInput :data-field="'lastname-'+ index" place-holder="Last Name" v-model="value.lastName" />
    <FormInput :data-field="'ipnumber-'+ index" place-holder="IP Number" v-model="value.ipNumber" />
    <EnumInput :data-field="'capacity-'+ index" place-holder="Capacity" v-model="value.capacity" :items="WriterCapacity" />
    <div class="col-l-3 col-m-4 col-5">
      <label :for="'controlled'+index">Controlled-{{ index }}</label>
    </div>
    <RadioInput :items="radioGroupOptions" :data-field="'controlled-'+ index" place-holder="Controlled" v-model="value.controlled" />
    <FormInput :data-field="'affiliation-'+ index" place-holder="Affiliation" v-model="value.affiliation" />
    <hr />
  </div>
</template>
<script setup>
/* eslint-disable */
  import EnumInput from '@/components/felements/EnumInput.vue';
import FormInput from '@/components/felements/FormInput.vue';
  import RadioInput from '@/components/felements/RadioInput.vue';
  import { WriterCapacity, WriterInfo } from '@/models/SongRegistration';
  import { defineModel } from 'vue';
  const radioGroupOptions = [{name: 'yes', value: true}, {name: 'no', value: false},]
  const songRegistration = defineModel('songRegistration')
</script>
<style lang="css" scoped>
  .writerminiform {
    margin-bottom: 10vh;
    padding-bottom: 5vh;
  }
</style>